import { compose } from "redux";
import { accountBalanceConnector } from "../../../services/menu/dashboard/account.balance.connector";
import { currencyTag, moneyFormater } from "../../../utilities/formaters";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Currencies } from "../../../shared/dictionary/enums";

const TaxAccountBalance = ({ accountBalance }) => {
  const sek = currencyTag[Currencies.Sek];
  const eur = currencyTag[Currencies.Eur];

  if (accountBalance[sek].fetched && accountBalance[eur].fetched) {
    let slTaxSek = accountBalance[sek].data.SavelendTax.Amount;
    let slTaxEur = accountBalance[eur].data.SavelendTax.Amount;

    return (
      <span>
        <div className={"col-md-12"}>
          <h3>Savelend account balances</h3>
        </div>
        <div className={"col-md-6"}>
          <strong>Savelend tax</strong>:{" "}
          {moneyFormater(Math.floor(slTaxSek * 100) / 100)} {sek}
        </div>
        <div className={"col-md-6"}>
          <strong>Savelend tax</strong>:{" "}
          {moneyFormater(Math.floor(slTaxEur * 100) / 100)} {eur}
        </div>
      </span>
    );
  }
  return <CircularProgress />;
};

export default compose(accountBalanceConnector)(TaxAccountBalance);
